import { useEffect } from 'react';
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGraduationCap, faCheck, faLayerGroup, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import FrontHeader from '../components/FrontHeader'
import FrontFooter from '../components/FrontFooter'

function TestPage() {
  useEffect(() => {
    if (window.particlesJS && typeof window.particlesJS.load === 'function') {
      window.particlesJS.load('particles-js', '/particles.json', function() {
      });
    } else {
      console.error('particlesJS is not defined or load method is not available');
    }
  }, []);
  return (
    <div>
      <div style={{backgroundColor: 'rgb(5, 8, 11)', position: 'relative'}}>
        <video autoPlay loop muted playsInline className="position-absolute top-0 left-0 w-100 h-100 object-cover" style={{ zIndex: '0' }}>
          <source src={require('../images/bg-video.mp4')} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div id='particles-js'></div>
        <div className="position-absolute top-0 left-0 w-100 h-100 bg-black" style={{zIndex: '10', opacity: '0.7'}}></div>
        <FrontHeader/>
        <div className="container position-relative" style={{zIndex: '12', paddingBottom: '8rem', paddingTop: '1rem'}}>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-12'>
              <div className='d-flex justify-content-center'>
              <img src={require('../images/hero_3x_B.webp')} alt="Mobile" className='img-fluid'/>
              </div>
            </div>
            <div className='col-lg-6 col-12'>
              <span className='mb-4 frontBtn fw-semibold text-uppercase text-white' style={{fontSize: '14px'}}>Bitkeyledger</span>
              <h1 className='fw-bold largeText' style={{lineHeight: '1'}}>Trade Crypto at the Best Possible Prices</h1>
              <p className='text-white pe-lg-5 me-lg-5'>Connect to 10+ liquidity providers at once and get the best possible price. Bitkeyledger Pro offers institutional trading tools to individuals — with a 50% discount on fees when paying with Bitkeyledger.</p>
              <div className='mt-5 d-flex align-items-center mobile-column'>
                <Link to='/register' className='myBtn bg-prime px-4 py-2-5 rounded-pill'>Get Started <FontAwesomeIcon icon={faAngleRight} className='ms-2' /></Link>
                <Link to='/login' className='myBtn px-4 py-2-5 rounded-pill ms-4 text-white'>Login Account <FontAwesomeIcon icon={faAngleRight} className='ms-2 text-white' /></Link>
              </div>
            </div>
          </div>
          <div className='row mt-5 mt-lg-0 px-lg-5'>
            <div className='col-lg-3 col-md-6 g-4'>
              <div className='d-flex align-items-center'>
                <img src={require('../images/leverage.8560d4ad15442108fe8615cad2bea8fe.svg').default} alt='leverage'/>
                <div className='ms-3'>
                  <p className='text-white fw-semibold mb-0'>Perpetual futures with up</p>
                  <p className='text-white fw-semibold mb-0'>to 50x leverage</p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 g-4'>
              <div className='d-flex align-items-center'>
                <img src={require('../images/hand-dollar.17a0c438e68050e578a4d2de3b89da42.svg').default} alt='leverage'/>
                <div className='ms-3'>
                  <p className='text-white fw-semibold mb-0'>Liquidity aggregation from</p>
                  <p className='text-white fw-semibold mb-0'>3,000 order books</p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 g-4'>
              <div className='d-flex align-items-center'>
                <img src={require('../images/market-order.c421a8c4b648f5b66001a7780a8a0b27.svg').default} alt='leverage'/>
                <div className='ms-3'>
                  <p className='text-white fw-semibold mb-0'>Market insights and custom</p>
                  <p className='text-white fw-semibold mb-0'>alerts</p>
                </div>
              </div>
            </div>
            <div className='col-lg-3 col-md-6 g-4'>
              <div className='d-flex align-items-center'>
                <img src={require('../images/shield-custodian.86b41e6b638b7277179757d30853ca08.svg').default} alt='leverage'/>
                <div className='ms-3'>
                  <p className='text-white fw-semibold mb-0'>Top-tier fundamentals &</p>
                  <p className='text-white fw-semibold mb-0'>custodial insurance</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section style={{paddingBottom: '3rem', backgroundColor: '#040405'}}>
        <div className="container">
          <div className='row justify-content-center'>
            <div className='col-lg-9 col-xl-8 col-xxl-7'>
              <div className='position-relative text-center'>
                <img src={require('../images/map_1.webp')} alt="Mobile"/>
                <img src={require('../images/map_country_1.webp')} className='position-absolute' alt="Mobile" style={{left:'5%', top: '15%'}}/>
                <img src={require('../images/map_country_2.webp')} className='position-absolute' alt="Mobile" style={{right:'35%', top: '20%'}}/>
                <img src={require('../images/map_country_4.webp')} className='position-absolute' alt="Mobile" style={{right:'7%', top: '53%'}}/>
                <img src={require('../images/map_country_3.webp')} className='position-absolute' alt="Mobile" style={{left:'15%', top: '55%'}}/>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white" style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-12">
              <div className="d-flex flex-column align-items-center">
                <img src={require('../images/analyst.png')} alt="Analytics" style={{width: '40px'}}/>
                <h5 className="fw-bold mt-4 mb-2" style={{color: '#2563eb'}}>Analytics</h5>
                <p className="text-dark text-center mb-0">Our platform delivers insightful analytics and strategic guidance, enabling you to optimize your financial decisions and achieve your financial objectives</p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="d-flex flex-column align-items-center">
                <img src={require('../images/portfolio.png')} alt="Diverse portfolio" style={{width: '40px'}}/>
                <h5 className="fw-bold mt-4 mb-2" style={{color: '#2563eb'}}>Diverse portfolio</h5>
                <p className="text-dark text-center mb-0">Utilize our platform to safeguard a substantial portfolio of assets, ensuring secure management and protection tailored to your individual needs.</p>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div className="d-flex flex-column align-items-center">
                <img src={require('../images/support.png')} alt="Live support" style={{width: '40px'}}/>
                <h5 className="fw-bold mt-4 mb-2" style={{color: '#2563eb'}}>Live support</h5>
                <p className="text-dark text-center mb-0">Our dedicated team of knowledgeable representatives is always ready to assist you with any concerns, or support you may need at any time of day. </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
          <h1 className="tex-white fw-bold mb-5 pb-5">Trusted by thousands of <br/> users worldwide</h1>
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">$100M+</h1>
                <p className="mb-0">Paid out to traders</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">180+</h1>
                <p className="mb-0">Countries registered with us</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">13M+</h1>
                <p className="mb-0">Volume of trades monthly</p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div style={{paddingLeft: '1.5rem', borderLeft: '1px solid #ffffff1a'}}>
                <h1 className="mb-3 text-white fw-bold">3h</h1>
                <p className="mb-0">Avg. payout processing time</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white" style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
          <h1 className="mb-3 text-center text-black">All your financial assets in one place</h1>
          <p className="mb-5 text-center text-dark">Get a stock account, foreign exchange broker and cryptocurrency exchange -in one refreshingly easy solution.</p>
          <img src={require('../images/markets.570e8cb2e10e06736455.png')} alt="Diverse portfolio" style={{width: '100%'}}/>
        </div>
      </section>
      <section style={{paddingBottom: '8rem', paddingTop: '8rem'}}>
        <div className="container">
          <p className="mb-0 text-center mb-2">RESELLTRADEMARKET CAMPUSES</p>
          <h1 className="mb-0 text-center fw-bold">10+ WEALTH CREATION METHODS</h1>
          <div className="row mt-5">
            <div className="col-lg-4 col-12">
              <div style={{backgroundColor: '#09141b'}}>
                <div className="p-3">
                  <img src={require('../images/RWShop.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>AMAZON FBA</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>Imagine launching a store overnight and tapping into the global marketplace by morning. E-Commerce is your gateway to rapid retail success.</p>
                </div>
                <img src={require('../images/RWEcommerce.jpg')} alt="photo" style={{width: '100%'}}/>
                <div className="p-3">
                  <img src={require('../images/RWCopy.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>COPYWRITING</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>Words are your warriors, and every sentence is a strategy. Master the craft of copywriting with us, and you'll learn to turn prose into profit.</p>
                </div>
                <img src={require('../images/RWCopywriting.jpg')} alt="photo" style={{width: '100%'}}/>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div style={{backgroundColor: '#09141b'}}>
                <div className="p-3">
                  <img src={require('../images/RWCoin.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>CRYPTO INVESTING</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>The Bull Run is making its rounds again early 2024. You need to be equipped. We cut through the complexity and get you to the core of crypto, where strategic investments meet swift returns.</p>
                </div>
                <img src={require('../images/RWCryptoInvesting.jpg')} alt="photo" style={{width: '100%'}}/>
                <div className="p-3">
                  <img src={require('../images/RWContent.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>CONTENT CREATION</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>We live in a digital age. There are websites worth more than skyscrapers. Videos worth more than houses. We will teach you how to create valuable digital assets and how to sell them.</p>
                </div>
                <img src={require('../images/RWContentCreation.jpg')} alt="photo" style={{width: '100%'}}/>
              </div>
            </div>
            <div className="col-lg-4 col-12">
              <div style={{backgroundColor: '#09141b'}}>
                <div className="p-3">
                  <img src={require('../images/RWCoin.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>CRYPTO TRADING</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>Take advantage of the bull run and master the art of crypto trading in the Crypto Trading campus, where we empower you to navigate the markets with precision.</p>
                </div>
                <img src={require('../images/RWCryptoTrading.jpg')} alt="photo" style={{width: '100%'}}/>
                <div className="p-3">
                  <img src={require('../images/RWBusiness.svg').default} alt="photo" className="mb-4" style={{height: '23px'}}/>
                  <p className="mb-2 text-uppercase text-white" style={{fontSize: '18px'}}>BUSINESS</p>
                  <p className="mb-0" style={{fontSize: '13px'}}>The Real World's business training is about mastering the art of leadership and scaling operations.</p>
                </div>
                <img src={require('../images/RWBusiness.jpg')} alt="photo" style={{width: '100%'}}/>
              </div>
            </div>
          </div>
          <p className="mb-0 text-center mb-2 mt-5 pt-5">A STEP-BY-STEP PATH</p>
          <h1 className="mb-0 text-center fw-bold">TOOLS TO MAXIMISE YOUR INCOME</h1>
          <div className="row mt-5">
            <div className="col-md-6">
              <img src={require('../images/RWPhone.webp')} alt="Diverse portfolio" style={{width: '100%'}}/>
            </div>
            <div className="col-md-6">
              <div className="d-flex align-items-center mb-4">
                <FontAwesomeIcon icon={faGraduationCap} className="me-2" style={{fontSize: '24px'}} />
                <h3 className="mb-0 fw-bold text-white">VITAL LIFE LESSONS</h3>
              </div>
              <div className="rw-li mb-3">
                <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>World-class custom built learning application</h5>
              </div>
              <div className="rw-li mb-3">
                <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Scale from Zero to $10k/month as fast as possible</h5>
              </div>
              <div className="rw-li mb-3">
                <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Master skills you need to maximize your income</h5>
              </div>
            </div>
            <div className="col-md-6">
              <img src={require('../images/RWPrivate.webp')} alt="Diverse portfolio" style={{width: '100%'}}/>
            </div>
            <div className="col-md-6">
              <div>
                <div className="d-flex align-items-center mb-4">
                  <FontAwesomeIcon icon={faGraduationCap} className="me-2" style={{fontSize: '24px'}} />
                  <h3 className="mb-0 fw-bold text-white">PRIVATE NETWORK</h3>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Celebrate your wins with people who understand</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Make like-minded friends on your journey</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Network with 113,000+ students</h5>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <img src={require('../images/RWAccess.webp')} alt="Diverse portfolio" style={{width: '100%'}}/>
            </div>
            <div className="col-md-6">
              <div>
                <div className="d-flex align-items-center mb-4">
                  <FontAwesomeIcon icon={faGraduationCap} className="me-2" style={{fontSize: '24px'}} />
                  <h3 className="mb-0 fw-bold text-white">ACCESS TO MULTIMILLIONAIRES</h3>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Mentors are hyper-successful experts in their field</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>Get mentored every step of your journey</h5>
                </div>
                <div className="rw-li mb-3">
                  <FontAwesomeIcon icon={faCheck} className="me-2" style={{fontSize: '18px'}} />
                  <h5 className="mb-0 fw-semibold" style={{fontSize: '18px'}}>1-on-1 advice from industry experts</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mb-2 mt-4">
            <Link to="/register" className="myBtn bg-prime px-4 py-2-5 rounded-5">JOIN THE REAL WORLD</Link>
          </div>
          <p className="mb-0 text-center fw-semibold"><FontAwesomeIcon icon={faLayerGroup} className="me-1" style={{fontSize: '16px'}} />Access 12+ wealth creation methods</p>
          <h1 className="mb-0 text-center fw-bold mt-5 pt-5 mb-4">Get started with trading today</h1>
          <p className="text-center mx-auto mb-4" style={{maxWidth: '36rem'}}>It’s easy to get started. Register an account with us and get started with trading today.</p>
          <div className="d-flex justify-content-center">
            <Link to="/register" className="myBtn bg-prime px-4 py-2-5 rounded-5">Get started</Link>
          </div>
        </div>
      </section>
      <FrontFooter/>
    </div>
  )
}

export default TestPage